import { render, staticRenderFns } from "./m-addAnswerEssayChild.vue?vue&type=template&id=3f35b898&"
import script from "./m-addAnswerEssayChild.vue?vue&type=script&lang=js&"
export * from "./m-addAnswerEssayChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports